import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Input, Table } from 'antd';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';

const { Search } = Input;

@inject('FnbAdditionalItemStore')
@observer
class FnbAdditionalItemSearchModalPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            searchText: '',
            searchedColumn: ''
        }
    }

    componentDidMount() {
    }

    getColumns = () => {
        const { t } = this.props;
        return [
            {
                title: t('In Room Dining'),
                dataIndex: 'taskName',
                key: 'taskName',
                width: '40%'
            },
            {
                title: t('Category'),
                dataIndex: 'categoryName',
                key: 'parentName',
                width: '40%'
            },
            {
                title: t('Action'),
                dataIndex: 'taskId',
                key: 'action',
                width: '10%',
                render: taskId => (
                    <span>
                        <Button onClick={() => this.selectItemOnClick(taskId)} type='primary'>
                            {t('Select')}
                        </Button>
                    </span>
                ),
            },
        ]
    }

    // ON CHANGE

    itemOnChange = e => {
        this.props.FnbAdditionalItemStore.setItemSearchValue(e.target.value);
        this.props.FnbAdditionalItemStore.searchItem();
    }

    // ON CLICK

    selectItemOnClick = taskId => {
        this.props.FnbAdditionalItemStore.searchItemSelected(taskId);
        this.props.FnbAdditionalItemStore.setShowFnbAdditinalItemSearchModal(false);
    }

    render() {
        const { t } = this.props;
        const {
            lastChildItemFilter,
            itemSearchValue
        } = this.props.FnbAdditionalItemStore;

        return (
            <React.Fragment>
                <Search style={{ marginBottom: 10 }} placeholder={t('Search Retail')} value={itemSearchValue} onChange={this.itemOnChange} />
                <Table columns={this.getColumns()} dataSource={lastChildItemFilter} />
            </React.Fragment>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(FnbAdditionalItemSearchModalPage);